import { t } from "@/lib/strings";
import { UserMultiSelect } from "@/components/memo/UserMultiSelect";
import type { MemoUser } from "@/lib/types";

const fieldLabel: React.CSSProperties = {
  fontSize: 12,
  fontWeight: 600,
  color: "var(--ink-2)",
  marginBottom: 4,
  display: "block",
};
const input: React.CSSProperties = {
  width: "100%",
  fontSize: 13,
  padding: "8px 10px",
  borderRadius: 8,
  border: "1px solid var(--hairline)",
  background: "var(--surface)",
  color: "var(--ink-1)",
  boxSizing: "border-box",
};

// Monday-first weekday labels; index maps directly to `default_weekday`
// (0=Montag … 6=Sonntag), the same convention `formatSeriesSchedule` uses.
const WEEKDAYS = [
  "Montag",
  "Dienstag",
  "Mittwoch",
  "Donnerstag",
  "Freitag",
  "Samstag",
  "Sonntag",
] as const;

export function SeriesFormFields({
  name,
  onName,
  sections,
  onSections,
  weekday,
  onWeekday,
  startTime,
  onStartTime,
  participants,
  onParticipants,
  editors,
  onEditors,
}: {
  name: string;
  onName: (v: string) => void;
  sections: string;
  onSections: (v: string) => void;
  weekday: number | null;
  onWeekday: (v: number | null) => void;
  startTime: string | null;
  onStartTime: (v: string | null) => void;
  participants: MemoUser[];
  onParticipants: (v: MemoUser[]) => void;
  editors: MemoUser[];
  onEditors: (v: MemoUser[]) => void;
}) {
  return (
    <>
      <div>
        <label style={fieldLabel}>{t.seriesNameLabel}</label>
        <input style={input} value={name} onChange={(e) => onName(e.target.value)} autoFocus />
      </div>
      <div>
        <label style={fieldLabel}>{t.seriesSectionsLabel}</label>
        <textarea
          style={{ ...input, minHeight: 120, fontFamily: "inherit", resize: "vertical" }}
          value={sections}
          onChange={(e) => onSections(e.target.value)}
        />
      </div>
      <div>
        <label style={fieldLabel}>{t.seriesTurnusLabel}</label>
        <div style={{ display: "flex", gap: 10 }}>
          <select
            style={{ ...input, flex: 1 }}
            value={weekday == null ? "" : String(weekday)}
            onChange={(e) => onWeekday(e.target.value === "" ? null : Number(e.target.value))}
          >
            <option value="">{t.seriesWeekdayNone}</option>
            {WEEKDAYS.map((label, i) => (
              <option key={i} value={i}>
                {label}
              </option>
            ))}
          </select>
          <input
            type="time"
            style={{ ...input, flex: 1 }}
            value={startTime ?? ""}
            onChange={(e) => onStartTime(e.target.value || null)}
          />
        </div>
      </div>
      <div>
        <label style={fieldLabel}>{t.seriesParticipantsLabel}</label>
        <UserMultiSelect value={participants} onChange={onParticipants} />
      </div>
      <div>
        <label style={fieldLabel}>{t.seriesEditorsLabel}</label>
        <UserMultiSelect value={editors} onChange={onEditors} />
      </div>
    </>
  );
}
